import { createContext } from "react";

const noop = () => {};

type CreateActionHandler = (
    task: Spintr.TaskListTask,
    callback: (success?: boolean | undefined) => void,
) => void;

export type QualityHubTasksListContextType = {
    /**
     * A function that advances the list from the current item to the next one.
     */
    advanceFrom: (itemId: number, immediateNeighbour?: boolean) => void;

    /**
     * A function that goes backward from the current item to the previous one.
     */
    backwardFrom: (itemId: number) => void;

    /**
     * A function that can be called when the user wants to create an action for
     * a task.
     */
    createAction: CreateActionHandler;

    /**
     * A function that sets the currently selected action.
     */
    setExpandedItemId: (itemId: number | undefined) => void;
};

const defaultContext: QualityHubTasksListContextType = {
    advanceFrom: noop,
    backwardFrom: noop,
    createAction: noop as CreateActionHandler,
    setExpandedItemId: noop,
} as const;

export const QualityHubTasksListContext = createContext<QualityHubTasksListContextType>(
    defaultContext
);

export const QualityHubTasksListContextProvider = QualityHubTasksListContext.Provider;
export const QualityHubTasksListContextConsumer = QualityHubTasksListContext.Consumer;
